import 'cirrus-ui'
import { NavigationButton } from './NavigationButton'
import Logo from '../resources/logo_v2.svg' 

export function NavigationBrand(props) {

    return (
        <div className="header-brand">
            <div className="nav-item no-hover p-1">
                <a href="./">
                    <img width="200em" src={Logo} alt={props.sitename} />
                </a>
            </div>
            <NavigationButton></NavigationButton>
        </div>
    )

}



